import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default (function (params) {
  const { exec, isRequestSuccessed } = useRequest({
    url: '',
    name: 'DELETE_USER_ORG_AUTHORITY',
    method: 'DELETE',
  });

  useEffect(() => {
    if (params) {
      exec(`/api/system/usersorgsauthority/${params.user_id}/${params.org_id}/${params.user_aid}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);
  return [exec, isRequestSuccessed];
});
